import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { catchError, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ToastService } from '../../shared/services/toast.service';

const AUTH_ENDPOINTS = ['/api/auth/login', '/api/auth/refresh'];

// AA-32: el access token ya no se lee de JS (cookie httpOnly) -- `withCredentials: true` es lo
// que hace que el navegador adjunte esa cookie (y la de refresh, cuando aplique) a cada request.
export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const toast = inject(ToastService);
  const authReq = req.clone({ withCredentials: true });
  const isAuthEndpoint = AUTH_ENDPOINTS.some(path => req.url.includes(path));

  return next(authReq).pipe(
    catchError(err => {
      // AA-68: un 401 fuera de login/refresh probablemente significa que el access token venció --
      // se intenta renovar en silencio con el refresh de larga duración (cookie httpOnly, no hay
      // forma de verificar desde JS si existe antes de intentarlo) y se reintenta la petición
      // original una sola vez, en vez de mandar al usuario a login de inmediato.
      if (err.status === 401 && !isAuthEndpoint) {
        return auth.refreshAccessToken().pipe(
          switchMap(() => next(req.clone({ withCredentials: true }))),
          catchError(refreshErr => {
            auth.logout();
            router.navigate(['/login']);
            return throwError(() => refreshErr);
          })
        );
      }
      // AA-31: 403 significa "autenticado pero sin permiso para esta empresa/acción" (TenantGuard
      // o @PreAuthorize) -- NUNCA debe cerrar la sesión, a diferencia de un 401 real. Antes se
      // trataban igual, lo que sacaba a un usuario legítimo de su sesión solo por intentar algo
      // fuera de su rol.
      if (err.status === 403) {
        toast.error(err.error?.message || 'Sin permiso para realizar esta acción.');
        return throwError(() => err);
      }
      if (err.status === 401) {
        auth.logout();
        router.navigate(['/login']);
      }
      return throwError(() => err);
    })
  );
};

